export const filterFilesByType = ({ files, types }) => {
  if (!types) {
    return Array.from(files);
  }

  return Array.from(files).filter((file) => types.includes(file.type));
};
